import { ReactNode, useEffect } from 'react';
import ReactGA from 'react-ga4';

import { useUser } from '@clerk/react';

import { useGTMUserProperties } from '../hooks';
import { useOnInit } from '../hooks/OnInit/useOnInit';
import { pushGTMEvent } from '../utils/analytics/gtm';
import { takeSignupMethod } from '../utils/analytics/signupMethod';

interface OnboardingLayoutProps {
  children: ReactNode;
}

const stylesheet = {
  main: 'relative w-full min-h-screen bg-semantic-bg-page',
  container: 'w-full h-full relative',
};

export function OnboardingLayout({
  children,
}: Readonly<OnboardingLayoutProps>) {
  const { user } = useUser();

  useGTMUserProperties();

  useEffect(() => {
    if (user) {
      ReactGA.set({ user_id: user.id });

      ReactGA.set({
        user_properties: {
          id: user.id,
          email: user.emailAddresses[0]?.emailAddress,
          firstName: user.firstName,
          lastName: user.lastName,
        },
      });

      const hasEmittedOAuthSignup = sessionStorage.getItem(
        'oauth_signup_success_emitted',
      );
      const oauthSource = sessionStorage.getItem('oauth_source');

      if (oauthSource === 'signup' && !hasEmittedOAuthSignup) {
        pushGTMEvent({
          event: 'signup_success',
          method: takeSignupMethod(),
        });

        sessionStorage.setItem('oauth_signup_success_emitted', 'true');

        sessionStorage.removeItem('oauth_source');
      }
    } else {
      ReactGA.set({ user_id: null });
    }
  }, [user]);

  useOnInit();

  return (
    <main className={stylesheet.main}>
      <div className={stylesheet.container}>{children}</div>
    </main>
  );
}
